'use client'

import { memo } from 'react'
import { cn } from '@/lib/utils'
import { useNinxl8BitThemeMode } from './use-ninxl-8bit-theme'

export const NINGENIE_PRODUCT_HUNT_URL =
  'https://www.producthunt.com/products/ningenie?utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-top-post-badge'

const NINGENIE_PH_DAY_RANK = 12

const NINGENIE_PH_BADGE_ALT = 'Ningenie: #12 Product of the Day on Product Hunt'

const dayRankBadgeSrc = (theme: 'light' | 'dark') =>
  `/ninxl/landing/ph-day-rank-${NINGENIE_PH_DAY_RANK}-${theme}.svg`

const BADGE_SIZES = {
  default: { width: 250, height: 54, className: 'h-[54px] w-[250px]' },
  compact: { width: 188, height: 41, className: 'h-[41px] w-[188px]' },
} as const

type ProductHuntBadgeSize = keyof typeof BADGE_SIZES

/** Official-style Product Hunt #12 day rank badge for Ningenie mobile */
export const NinxlNingenieProductHuntBadge = memo(function NinxlNingenieProductHuntBadge({
  className,
  size = 'default',
}: {
  className?: string
  size?: ProductHuntBadgeSize
}) {
  const theme = useNinxl8BitThemeMode()
  const phTheme = theme === 'dark' ? 'dark' : 'light'
  const dimensions = BADGE_SIZES[size]

  return (
    <a
      href={NINGENIE_PRODUCT_HUNT_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={NINGENIE_PH_BADGE_ALT}
      className={cn('inline-block transition hover:opacity-90', className)}
      onClick={(event) => event.stopPropagation()}
    >
      <img
        src={dayRankBadgeSrc(phTheme)}
        alt={NINGENIE_PH_BADGE_ALT}
        width={dimensions.width}
        height={dimensions.height}
        className={dimensions.className}
      />
    </a>
  )
})